import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { ValidarDatosFactura } from "../../Credito/FacturarEquipo/ValidaDatosFactura";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import BusinessIcon from "@mui/icons-material/Business";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { InputAdornment, TextField } from "@mui/material";
import { ValTextAndNumber } from "../../../Validators/ValTextAndNumber";
import { TextFieldCliente } from "../../Credito/FacturarEquipo/TextFieldCliente";
import { ValOnlyNumber } from "../../../Validators/ValOnlyNumber";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";


export const MhusaCargarPAgareEquip = ({
  folio,
  setLoader,
  loader,
  updateComentarios,
  // Inyectado por ModalSolicitudCredito (ver ModalSCScreens). Habilita
  // "Siguiente" tras registrar una unidad, sin cerrar el modal.
  habilitarSiguiente,
}) => {
  const [datos_pedido, setDatos_pedido] = useState({});
  const [mostrar_registro, setMostrar_Regisrtro] = useState(false);
  const [financiamiento, setFinanciamiento] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [documentosequipo, setDocumentosEQUIP] = useState([]);
  const [datos_facturacion, setDatosFacturacion] = useState({
    comentarios: "",
    comentarioscredito: "",
    estado: "",
    tiempoestimado: "",
    tiempotranscurrido: "",
    factura: false,
    nota_abono: false,
    idequip: "",
    idsucursal: "",
    serie_fiscal: "",
    folio_fiscal: "",
    documento: "",
  });
  const [sucursales_cliente, setSucursales_cliente] = useState([]);
  const [selected, setselected] = useState(null);
  const [factura, setFactura] = useState({
    documento: "",
    extension: "",
  });



  const [estatus, setEstatus] = useState({});
  const onImprimirArchivo = (iddocumento) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `SolicitudCreditoDocumentacion/ObtenerFactura?folio=${folio}&registro=${selected.registro
        }&iddocumento=${Number(iddocumento)}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = result.comentarios;
        const downloadLink = document.createElement("a");
        const fileName = `${result.documento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };
  const onGuardar = () => {
    if (
      documentosequipo === undefined ||
      documentosequipo === null ||
      documentosequipo.length === 0
    ) {
      Swal.fire(
        "CAPTURAR INFORMACION EQUIP",
        "Favor de agregar los documentos",
        "warning"
      );
      return;
    }
    const validate = {
      post: {
        folio,
        factura: "",
        // nota_abono: nota.documento,
        comentarios: "Se registro la información EQUIP",
        estatus: "A",
        idequip: "",
        idsucursal: 0,
        serie_fiscal: "",
        folio_fiscal: "",
        documentos: documentosequipo,
        registro: selected.registro,
      },
    };
    setLoader({ ...loader, mostrar: true });
    request
      .post("ACJDF_Cargar_Factura/GuardarMhusaDetalle", validate.post)
      .then(async (result) => {
        setLoader({ ...loader, mostrar: false });
        setDatosFacturacion([]);

        // Habilita "Siguiente" sin recargar data/estado ni cerrar el modal.
        if (habilitarSiguiente !== undefined && habilitarSiguiente !== null)
          habilitarSiguiente();

        await Swal.fire(
          "FACTURACION",
          "Factura Registrada con exito",
          "success"
        );
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("FACTURACION", JSON.stringify(error), "error");
      });
  };
  const OnGetIcon = ({ icon }) => {
    switch (icon) {
      case "wait":
        return <PendingIcon />;
      case "success":
        return <CheckCircleIcon />;
      case "warning":
        return <WarningIcon />;
      case "error":
        return <ErrorIcon />;
      default:
        <></>;
    }
  };
  //Informacion del pedido
  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`FacturarEquipo/informacion_pedido?folio=${folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setDatos_pedido(result.datos_pedido);
        setFinanciamiento(result.financiamiento);
        setUnidades(result.unidades);
        setEstatus(result.informacion);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("FACTURACION", JSON.stringify(error), "error");
      });
  }, []);

  //Informacion de cada unidad
  const onBuscarFactura = (item) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `FacturarEquipo/informacion_pedido_unidad?folio=${folio}&registro=${Number(
          item.registro
        )}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setDatosFacturacion(result.datos_pedido);
        setSucursales_cliente(result.sucursales);
        if (
          result.datos_pedido.serie_fiscal !== undefined ||
          result.datos_pedido.serie_fiscal !== null ||
          result.datos_pedido.serie_fiscal !== ""
        )
          setMostrar_Regisrtro(true);

        setselected(item);
        setDocumentosEQUIP(result.documentos);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("FACTURACION", JSON.stringify(error), "error");
      });
  };
  const [updatedocumento, setupdatedocumento] = useState(null);

  const updateDocumento = (index, value) => {
    var newvalue = documentosequipo;
    newvalue[index].documento = value;
    newvalue = [...newvalue, { orden: 0, documento: "" }];
    setDocumentosEQUIP(newvalue);
    setupdatedocumento(!(updatedocumento === null ? true : updatedocumento));
  };

  const updateDocumentoFinanciamiento = (index, value) => {
    var newvalue = documentosequipo;
    newvalue[index].docto_financiamiento = value;
    newvalue = [...newvalue, { orden: 0, documento: "" }];
    setDocumentosEQUIP(newvalue);
    setupdatedocumento(!(updatedocumento === null ? true : updatedocumento));
  };

  useEffect(() => {
    if (updatedocumento !== null) {
      const registros = documentosequipo.length;
      setDocumentosEQUIP(
        documentosequipo.filter((aa, index) => index !== registros - 1)
      );
    }
  }, [updatedocumento]);
  const onDatosFacturacion = (prop, value, sbool, smensaje) => {
    setDatosFacturacion({
      ...datos_facturacion,
      [prop]: value,
    });
  };
  const onEliminarDocumento = (orden, index) => {
    if (orden !== 0) {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `FacturarEquipo/EliminarRegistro?folio=${folio}&orden=${Number(
            orden
          )}&registro=${Number(selected.registro)}`
        )
        .then(() => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("Facturación de Equipo", "Registro eliminado", "success");
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("FACTURACION", JSON.stringify(error), "error");
        });
    }
    setDocumentosEQUIP(
      documentosequipo.filter((e, position) => position !== index)
    );
  };
  return (
    <div className="Facturar-equipo-timeline">
      <div className="solicitud-credito-a-facturar">
        <div className="solicitud-credito-datos-pedido scroll-4">
          <TextField
            label="Razon social"
            value={datos_pedido.razonsocial}
            size="small"
            color="success"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <BusinessIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="RFC"
            value={datos_pedido.rfc}
            size="small"
            color="success"
            sx={{ mt: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <BusinessIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Método de pago"
            value={datos_pedido.metodopago}
            size="small"
            color="success"
            sx={{ mt: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ReceiptIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Forma de pago"
            value={datos_pedido.formapago}
            size="small"
            color="success"
            sx={{ mt: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ReceiptIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Uso de CFDI"
            value={datos_pedido.usocfdi}
            size="small"
            color="success"
            sx={{ mt: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ReceiptIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Tipo de relación"
            value={datos_pedido.tiporel}
            size="small"
            color="success"
            sx={{ mt: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ReceiptIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Anticipos"
            value={datos_pedido.anticipos}
            size="small"
            color="success"
            sx={{ mt: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ReceiptIcon />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Folios de anticipos"
            value={datos_pedido.foliosanticipos}
            size="small"
            color="success"
            sx={{ mt: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ReceiptIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div className="solicitud-credito-info-facturar scroll-4">
          <div className="header">Datos de factura</div>
          {/* Tabla para representar los equipos solicitados*/}
          <div className="container-table-unidades">
            <table cellPadding={0} cellSpacing={0}>
              <thead>
                <tr>
                  <th>Linea</th>
                  <th>Modelo</th>
                  <th>Importe</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {unidades.map((item) => (
                  <tr>
                    <td>{item.linea}</td>
                    <td>{item.modelo}</td>
                    <td>{FormatMoney(item.importe)}</td>
                    <td>
                      <ReceiptLongIcon onClick={() => onBuscarFactura(item)} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Tabla de los detalles del financiamiento*/}
          <div className="container-table-financiamiento">
            <table cellPadding={0} cellSpacing={0}>
              <thead>
                <tr>
                  <th>Docto</th>
                  <th>Vencimiento</th>
                  <th>Importe</th>
                  <th>Interes</th>
                  <th>Total Pagar</th>
                </tr>
              </thead>
              <tbody>
                {financiamiento.map((item) => (
                  <tr>
                    <td>{item.docto}</td>
                    <td>{item.vencimiento}</td>
                    <td>{FormatMoney(item.importefinanciar)}</td>
                    <td>{FormatMoney(item.interes)}</td>
                    <td>{FormatMoney(item.totalpagar)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/*FACTURAS */}
          {selected !== undefined && selected !== null && (
            <div className="solicitud-credito-factura">
              <div className="solicitud-credito-factura-header">
                {`${selected.modelo} (${FormatMoney(selected.importe)})`}
              </div>
              <TextField
                fullWidth
                size="small"
                label="SERIE FISCAL"
                className="col1"
                type="text"
                onChange={({ target }) => {
                  ValTextAndNumber(
                    "serie_fiscal",
                    target.value,
                    onDatosFacturacion,
                    true,
                    10
                  );
                }}
                value={datos_facturacion.serie_fiscal}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <ReceiptIcon />
                    </InputAdornment>
                  ),
                }}
                disabled={true}
              />
              <TextField
                fullWidth
                size="small"
                label="FOLIO FISCAL"
                className="col2"
                type="text"
                onChange={({ target }) => {
                  ValTextAndNumber(
                    "folio_fiscal",
                    target.value,
                    onDatosFacturacion,
                    true,
                    10
                  );
                }}
                value={datos_facturacion.folio_fiscal}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <ReceiptIcon />
                    </InputAdornment>
                  ),
                }}
                disabled={true}
              />
              <TextField
                fullWidth
                size="small"
                label="DOCUMENTO EQUIP"
                className="cel3"
                type="text"
                onChange={({ target }) => {
                  ValOnlyNumber(
                    "documento",
                    target.value,
                    onDatosFacturacion,
                    true,
                    10
                  );
                }}
                value={datos_facturacion.documento}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <ReceiptIcon />
                    </InputAdornment>
                  ),
                }}
                disabled={true}
              />
              <TextFieldCliente
                array={sucursales_cliente}
                onDatosFacturacion={onDatosFacturacion}
                idequip={datos_facturacion.idequip}
              />
              <TextField
                fullWidth
                size="small"
                label="SUCURSAL"
                className="col5"
                type="text"
                value={datos_facturacion.sucursal}
                disabled={true}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <BusinessIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <div className="col8">
                <div className="label-facturacion">CARGAR FACTURA</div>
                <TextField
                  // label="Cargar Factura"
                  fullWidth
                  size="small"
                  type="file"
                  disabled={true}
                />
                {datos_facturacion.factura === true && (
                  <CheckCircleIcon
                    className="has_document"
                    onClick={() => onImprimirArchivo(28)}
                  />
                )}
              </div>
              <table
                className="solicitud-credito-detalle-factura"
                cellPadding={0}
                cellSpacing={0}
              >
                <thead>
                  <tr>
                    <th>Documentos Equip</th>
                    <th>Documentos Financiamiento</th>
                    <th>
                      {estatus.habilitar === true && (
                        <AddCircleIcon
                          onClick={() =>
                            setDocumentosEQUIP([
                              ...documentosequipo,
                              { orden: 0, documento: "", docto_financiamiento: "" },
                            ])
                          }
                        ></AddCircleIcon>
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {documentosequipo.map((item, index) => (
                    <tr>
                      <td colSpan={1}>
                        <DeleteForeverIcon
                          onClick={() => onEliminarDocumento(item.orden, index)}
                        ></DeleteForeverIcon>

                        <input
                          id={`ìnput-${index}`}
                          value={item.documento}
                          onChange={({ target }) =>
                            updateDocumento(index, target.value)
                          }
                        ></input>
                      </td>
                      <td colSpan={2}>
                        <input
                          id={`ìnput-${index}`}
                          value={item.docto_financiamiento}
                          onChange={({ target }) =>
                            updateDocumentoFinanciamiento(index, target.value)
                          }
                        ></input>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {mostrar_registro === true && estatus.habilitar === true && (
            <div className="solicitud-credito-footer">
              <div
                className="solicitud-credito-footer-guardar"
                onClick={() => {
                  onGuardar();
                }}
              >
                <CheckCircleIcon />
                <div>REGISTRAR</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};